// extracted by mini-css-extract-plugin
export default {"back_btn":"HistoryPage_back_btn__ifBae","back":"HistoryPage_back__t9FED"};